export const salonaBorderData: number[][] = [
  [2350, 150],
  [2350, -750],
  [2250, -650],
  [2150, -600],
  [2050, -600],
  [2000, -600],
  [1900, -530],
  [1840, -350],
  [1750, -300],
  [1650, -200],
  [1560, -100],
  [1500, 50],
  [1530, 150],
  [1530, 250],
  [1550, 350],
  [1500, 450],
  [1450, 550],
  [1400, 650],
  [1350, 750],
  [1330, 850],
  [1250, 950],
  [1150, 1050],
  [1080, 1050],
  [1000, 1150],
  [930, 1250],
  [900, 1300],
  [850, 1250],
  [800, 1300],
  [700, 1170],
  [660, 1070],
  [560, 1170],
  [460, 1200],
  [400, 1250],
  [350, 1100],
  [300, 1150],
  [250, 1200],
  [200, 1150],
  [170, 1050],
  [100, 1100],
  [50, 1150],
  [0, 1050],
  [-50, 1100],
  [-100, 1150],
  [-100, 1250],
  [-100, 1350],
  [-100, 1450],
  [-100, 1550],
  [-200, 1650],
  [-300, 1750],
  [-400, 1850],
  [-500, 1950],
  [-600, 2050],
  [-700, 2150],
  [-760, 2250],
  [-740, 2350],
  [-740, 2450],
  [-740, 2650],
  [-740, 2850],
  [-740, 3000],
  [-440, 3000],
  [-380, 3050],
  [-300, 3150],
  [-250, 3230],
  [-230, 3030],
  [-150, 2940],
  [-100, 2900],
  [-50, 2880],
  [0, 2850],
  [50, 2820],
  [100, 2775],
  [150, 2755],
  [200, 2750],
  [250, 2765],
  [300, 2790],
  [350, 2800],
  [380, 2800],
  [380, 2780],
  [370, 2770],
  [370, 2750],
  [380, 2735],
  [400, 2735],
  [430, 2705],
  [480, 2730],
  [530, 2740],
  [550, 2730],
  [570, 2740],
  [570, 2780],
  [600, 2815],
  [630, 2805],
  [680, 2785],
  [730, 2770],
  [770, 2770],
  [770, 2800],
  [810, 2840],
  [810, 2870],
  [810, 2890],
  [820, 2900],
  [840, 2900],
  [850, 2870],
  [870, 2860],
  [875, 2840],
  [895, 2830],
  [895, 2815],
  [885, 2815],
  [885, 2795],
  [900, 2780],
  [950, 2780],
  [1000, 2820],
  [1040, 2820],
  [1045, 2870],
  [1070, 2875],
  [1075, 2895],
  [1090, 2895],
  [1090, 2915],
  [1080, 2925],
  [1080, 2925],
  [1080, 2960],
  [1085, 2975],
  [1060, 3010],
  [1060, 3025],
  [1040, 3050],
  [1040, 3070],
  [1015, 3100],
  [1015, 3130],
  [1040, 3165],
  [1040, 3195],
  [1060, 3205],
  [1100, 3245],
  [1100, 3290],
  [1070, 3340],
  [1030, 3370],
  [1020, 3435],
  [1025, 3455],
  [995, 3455],
  [965, 3475],
  [920, 3485],
  [890, 3485],
  [860, 3500],
  [840, 3515],
  [820, 3515],
  [800, 3495],
  [775, 3490],
  [755, 3475],
  [730, 3475],
  [715, 3485],
  [715, 3520],
  [750, 3540],
  [770, 3555],
  [790, 3585],
  [795, 3610],
  [775, 3630],
  [750, 3655],
  [740, 3670],
  [740, 4175],
  [780, 4215],
  [820, 4245],
  [860, 4290],
  [895, 4295],
  [925, 4300],
  [955, 4280],
  [980, 4265],
  [1040, 4285],
  [1075, 4285],
  [1100, 4310],
  [1120, 4325],
  [1140, 4325],
  [1150, 4320],
  [1170, 4320],
  [1180, 4330],
  [1180, 4345],
  [1200, 4350],
  [1215, 4355],
  [1235, 4335],
  [1255, 4340],
  [1265, 4355],
  [1290, 4375],
  [1340, 4350],
  [1370, 4335],
  [1400, 4300],
  [1410, 4285],
  [1425, 4285],
  [1455, 4255],
  [1450, 4205],
  [1435, 4155],
  [1445, 4125],
  [1445, 4090],
  [1465, 4005],
  [1460, 3975],
  [1415, 3930],
  [1415, 3910],
  [1395, 3825],
  [1370, 3810],
  [1370, 3755],
  [1380, 3735],
  [1410, 3720],
  [1415, 3655],
  [1430, 3645],
  [1400, 3635],
  [1385, 3595],
  [1370, 3595],
  [1355, 3610],
  [1335, 3610],
  [1305, 3590],
  [1305, 3575],
  [1325, 3570],
  [1370, 3530],
  [1385, 3520],
  [1425, 3545],
  [1455, 3555],
  [1495, 3555],
  [1510, 3550],
  [1565, 3525],
  [1585, 3520],
  [1580, 3500],
  [1585, 3470],
  [1615, 3440],
  [1675, 3440],
  [1695, 3450],
  [1805, 3450],
  [1820, 3425],
  [1820, 3410],
  [1840, 3390],
  [1855, 3385],
  [1905, 3350],
  [1910, 3325],
  [1940, 3320],
  [1955, 3310],
  [1960, 3290],
  [2000, 3255],
  [2000, 3205],
  [2010, 3185],
  [1985, 3185],
  [1975, 3170],
  [1975, 3145],
  [2040, 3075],
  [2025, 3045],
  [2025, 3015],
  [2070, 2990],
  [2100, 2960],
  [2150, 2930],
  [2150, 2910],
  [2145, 2900],
  [2155, 2870],
  [2175, 2840],
  [2205, 2835],
  [2220, 2800],
  [2260, 2770],
  [2310, 2750],
  [2340, 2720],
  [2370, 2720],
  [2400, 2700],
  [2450, 2670],
  [2500, 2630],
  [2550, 2590],
  [2600, 2540],
  [2650, 2500],
  [2700, 2415],
  [2730, 2390],
  [2735, 2330],
  [2720, 2285],
  [2720, 2265],
  [2740, 2255],
  [2750, 2200],
  [2750, 2185],
  [2735, 2175],
  [2735, 2150],
  [2740, 2145],
  [2740, 2135],
  [2730, 2125],
  [2730, 2110],
  [2740, 2105],
  [2740, 2090],
  [2725, 2080],
  [2735, 2060],
  [2715, 2035],
  [2715, 2000],
  [2700, 2000],
  [2685, 2000],
  [2635, 1960],
  [2635, 1920],
  [2600, 1885],
  [2600, 1720],
  [2620, 1680],
  [2640, 1640],
  [2660, 1600],
  [2660, 1560],
  [2640, 1530],
  [2605, 1500],
  [2600, 1405],
  [2560, 1375],
  [2550, 1315],
  [2555, 1310],
  [2555, 1295],
  [2545, 1295],
  [2525, 1300],
  [2460, 1185],
  [2460, 1175],
  [2475, 1150],
  [2475, 1100],
  [2455, 1065],
  [2425, 1100],
  [2395, 1100],
  [2360, 1075],
  [2360, 1055],
  [2435, 985],
  [2500, 885],
  [2490, 825],
  [2480, 820],
  [2445, 825],
  [2365, 780],
  [2355, 760],
  [2345, 730],
  [2290, 695],
  [2210, 720],
  [2190, 710],
  [2190, 685],
  [2155, 660],
  [2115, 665],
  [2090, 650],
  [2090, 585],
  [2060, 535],
  [2055, 470],
  [2085, 420],
  [2110, 400],
  [2115, 360],
  [2095, 340],
  [2125, 310],
  [2115, 300],
  [2125, 270],
  [2120, 240],
  [2150, 230],
  [2175, 245],
  [2175, 265],
  [2145, 275],
  [2165, 295],
  [2160, 315],
  [2220, 325],
  [2215, 350],
  [2235, 355],
  [2245, 345],
  [2245, 325],
  [2215, 300],
  [2215, 285],
  [2240, 285],
  [2245, 260],
  [2280, 195],
  [2350, 150],
];
